import React from 'react';
import './heading.css';

export default function Heading(props) {
  if (props.fixed) {
    return FixedHeading(props);
  }
  return (
    <div className='heading-wrapper'>
      <div className='heading'>{props.children}</div>
    </div>
  );
}

function FixedHeading(props) {
  return (
    <div className='heading-wrapper heading-wrapper-wide'>
      <div className='heading heading-fixed'>{props.children}</div>
      <div className='heading heading-fixed-hack'>{props.children}</div>
    </div>
  );
}